import React, { useState, useEffect } from 'react';
import Table from '../common/Table';
import tableConfig, { data } from './config';
import { getUsers, deleteuser } from '../../actions/users';
import { GET_USERS } from '../../constants';
import { toast } from 'react-toastify';
import { withRouter } from 'react-router-dom';
import { CsvBuilder } from 'filefy';
import "./Users.css";
const Users = props => {
  const { classes, onView } = props;
  let config = tableConfig(props);
  const [users, setUsers] = useState([]);
  const [data, setData] = useState([]);
  let session = sessionStorage.getItem('user');
  const [isLoading, setLoading] = useState(false);
  const [countryid, setCountryid] = useState(null);

  useEffect(() => {
    if (session) {
      setCountryid(`${JSON.parse(session).findAdmin.country_id}`)
    }
  }, [session])

  const [tableKey, setTableKey] = useState(1);

  const onViewDetails = rowdata => {
    //console.log('rowData', rowdata);
    // props.history.push(`/users/${rowdata.user_id}`);
    window.open(`/users/${rowdata.user_id}`, '_blank');
    //onView();
  };
  const onDelete = rowdata => {
    setLoading(true);
    deleteuser(rowdata.user_id, (message, isError) => {
      const method = isError ? 'error' : 'success';
      toast[method](message);
      setLoading(false);
      if (method === 'success') {
        setTableKey(tableKey + 1);
      }
    });
  };

  const exportCsv = (columns, data) => {
    const columnTitles = columns.map(columnDef => columnDef.title);
    const csvExportData = []
    const orderFileds = [
      { name: 'name', subField: "" },
      { name: 'email_id', subField: "" },
      { name: 'mobile_no', subField: "" },
      { name: 'created_date', subField: "" },
    ]

    const ordersData = data.map(order => {
      const ordersDataDetails = []
      const orderData = orderFileds.map((orderFiled) => {
        let orderValue = order[orderFiled.name]
        if (orderFiled.subField && orderValue) {
          orderValue = order[orderFiled.name] && order[orderFiled.name][orderFiled.subField]
        }

        return orderValue
      })

      ordersDataDetails.push(...orderData)
      return ordersDataDetails
    })

    csvExportData.push(...(ordersData || []))
    const builder = new CsvBuilder("user.csv")
      .setColumns(columnTitles)
      .addRows(csvExportData);

    builder.exportFile()

    return builder;
  }
  ''
  return (
    <div className='users-restaurants-table-wrapper'>
      <Table
        key={tableKey}
        tableConfig={config}
        data={users}
        onView={onViewDetails}
        // onDelete={onDelete}
        apidata="users"
        pageSize={5}
        countryid={countryid}
        url={`${GET_USERS}`}
        exportCsv={exportCsv}
      />
    </div>
  );
};

export default withRouter(Users);
